import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { PageLayout } from '@rossum/components/page-layout/PageLayout';
import { DatasetsHeader } from '../header';
import { datasetTablePath } from '../routes';
import { Dataset } from '../types';

export type DatasetTab = 'data' | 'settings' | 'logs';

type DatasetDetailLayoutProps = {
  table: Dataset;
  tab: DatasetTab;
  buttons?: ReactNode[];
  fullWidth?: boolean;
  children: ReactNode;
};

// Shared shell of the dataset tabs: header with breadcrumbs and tabs.
export const DatasetDetailLayout = ({
  table,
  tab,
  buttons,
  fullWidth,
  children,
}: DatasetDetailLayoutProps) => {
  const intl = useIntl();

  return (
    <PageLayout
      fullWidth={fullWidth}
      renderHeader={props => (
        <DatasetsHeader
          {...props}
          datasetId={table.name}
          datasetTab={tab}
          title={table.metadata.name}
          description={table.metadata.description}
          breadcrumbs={[
            {
              label: table.metadata.name,
              to: datasetTablePath(table.name),
            },
            {
              label: intl.formatMessage({
                id: `features.datasets.${tab}.title`,
              }),
            },
          ]}
          buttons={buttons}
        />
      )}
    >
      {children}
    </PageLayout>
  );
};
